import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Address } from "./types";

interface AddressStepProps {
  address: Address;
  onAddressChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddressStep = ({ address, onAddressChange }: AddressStepProps) => {
  return (
    <>
      <div className="text-center">
        <h3 className="text-2xl font-bold text-primary-dark">
          Your Address
        </h3>
        <p className="text-neutral mt-2">
          Please provide your address details
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="street" className="text-primary-dark font-medium">Street Address</Label>
          <Input
            id="street"
            name="street"
            value={address.street}
            onChange={onAddressChange}
            placeholder="123 Main St"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>

        <div>
          <Label htmlFor="city" className="text-primary-dark font-medium">City</Label>
          <Input
            id="city"
            name="city"
            value={address.city}
            onChange={onAddressChange}
            placeholder="Chicago"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>

        <div>
          <Label htmlFor="state" className="text-primary-dark font-medium">State</Label>
          <Input
            id="state"
            name="state"
            value={address.state}
            onChange={onAddressChange}
            placeholder="Illinois"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>

        <div>
          <Label htmlFor="zipCode" className="text-primary-dark font-medium">ZIP Code</Label>
          <Input
            id="zipCode"
            name="zipCode"
            value={address.zipCode}
            onChange={onAddressChange}
            placeholder="60601"
            className="mt-1.5 bg-white/50 backdrop-blur-sm border-[#E5DEFF] focus:border-primary focus:ring-primary/20 transition-colors placeholder:text-neutral/60"
          />
        </div>
      </div>
    </>
  );
};

export default AddressStep;